// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const path = require("path-browserify")
const { createCardRoutes } = require("lib/core/routing/card-routing")
const { loadResourcePathStep } = require("path/middleware")
import EditStepSettingsCard from "@pathwright/web/src/modules/path/edit/EditStepSettingsCard"
import LibraryResourceContainer from "../../../library/show/components/LibraryResourceContainer"

const EditStepSettingsCardContainer = ({ card, match }) => {
  return (
    <EditStepSettingsCard
      card={card}
      source_id={parseInt(match.params.pathItemSourceId)}
      cohort_id={parseInt(match.params.cohortId)}
      onSubmit={card.onClose}
    />
  )
}

const EditStepMoreSettingsCardContainer = ({ card, match }) => {
  return (
    <EditStepSettingsCard
      card={card}
      displayMoreSettings={true}
      source_id={parseInt(match.params.pathItemSourceId)}
      cohort_id={parseInt(match.params.cohortId)}
      onSubmit={card.onClose}
    />
  )
}

EditStepSettingsCardContainer.displayName = "EditStepSettingsCardContainer"

const basePath =
  "/library/:resourceSlug/:cohortId(\\d+)/:section/:pathItemType(step)/:pathItemSourceId(\\d+)/"
const pathSettingsRoutes = {
  settings: {
    component: EditStepSettingsCardContainer,
    middleware: loadResourcePathStep,
    getDefaultLaunchedFrom({ location }) {
      return path.join(location.pathname, "../")
    },
    childCards: {
      "more-settings": {
        component: EditStepMoreSettingsCardContainer,
        middleware: loadResourcePathStep
      }
    }
  }
}

export default createCardRoutes(
  basePath,
  pathSettingsRoutes,
  LibraryResourceContainer
)
